import { createContext } from 'react';
import { SettingsSection } from 'shared/dialogs/user-settings/settings-nav';

import { SettingsOpenOrigin } from './settings-open-origin';

export type UserSettingsContextProps = {
  // absent = default section; a target section threads to the form's initial activeSection, not a route
  openSettings: (
    section?: SettingsSection,
    origin?: SettingsOpenOrigin,
  ) => void;
  openChangePassword: () => void;
  // The surface that opened the dialog, cleared on every open that doesn't name one.
  openOrigin?: SettingsOpenOrigin;
};

export const UserSettingsContext = createContext<UserSettingsContextProps>({
  openSettings: () => {},
  openChangePassword: () => {},
});
